module.exports = __webpack_public_path__ + "static/media/joshua.529a2488.jpg";